import { render, staticRenderFns } from "./MercadoPago.vue?vue&type=template&id=6227ee52&scoped=true&"
import script from "./MercadoPago.vue?vue&type=script&lang=js&"
export * from "./MercadoPago.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6227ee52",
  null
  
)

export default component.exports